export default {
    TOGGLE_LOADING: 'TOGGLE_LOADING',
    GIGS_TRANSLATED: 'GIGS_TRANSLATED',
    FILTER_APPLIED: 'FILTER_APPLIED',
    SC_FILTER_APPLIED: 'SC_FILTER_APPLIED'
};
